import { render, staticRenderFns } from "./Selection-0.1.3.vue?vue&type=template&id=4c2aab22&scoped=true&"
import script from "./Selection-0.1.3.vue?vue&type=script&lang=js&"
export * from "./Selection-0.1.3.vue?vue&type=script&lang=js&"
import style0 from "./Selection-0.1.3.vue?vue&type=style&index=0&id=4c2aab22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2aab22",
  null
  
)

export default component.exports